<div class="viewport viewport-full viewport-center bg-white">
  <div class="content">
    <kendo-stepper
      stepType="full"
      [steps]="steps"
      [linear]="false"
      [(currentStep)]="currentStep"
    >
      <ng-template kendoStepperLabelTemplate let-step>
      </ng-template>
    </kendo-stepper>
    <section>
      @switch (currentStep) {
        @case (1) {
          <app-step2 [quotation]="quotation"></app-step2>
        }
        @case (2) {
          <app-step3 [quotation]="quotation"></app-step3>
        }
        @case (3) {
          <app-step4 [quotation]="quotation"></app-step4>
        }
        @case (4) {
          <app-step5 [quotation]="quotation" (emailValidChange)="emailHandler($event)" [emailError]="emailError" [userExistsError]="userExistsError"></app-step5>
        }
        @default {
          <app-step1 [quotation]="quotation" [missingNameError]="missingNameError" [missingStartDateError]="missingStartDateError" [missingEndDateError]="missingEndDateError"></app-step1>
        }
      }
    </section>
    <footer>
      @if (currentStep > 0) {
        <button kendoButton themeColor="primary" size="large" style="border-radius: 20px; min-width: 100px" (click)="previousStepHandler()">
          {{ 'back' | translate }}
        </button>
      }
      @if (currentStep < steps.length - 1) {
        <button kendoButton themeColor="primary" size="large" style="border-radius: 20px; min-width: 100px" (click)="nextStepHandler()" [ngStyle]="currentStep === 0 ? { 'margin-right': '0px', 'margin-left' : 'auto' } : {}">
          {{ 'continue' | translate }}
        </button>
      }
      @if (currentStep === steps.length - 1) {
        <button kendoButton themeColor="primary" size="large" (click)="submit()">
          {{ 'requestQuotation' | translate }}
        </button>
      }
    </footer>
  </div>
  <div class="logo-wrapper" [ngClass]="'step-' + currentStep">
    <img ngSrc="/images/logo_white.png" alt="Famulus Logo" priority fill>
  </div>
</div>
<!--
<re-captcha siteKey="YOUR_RECAPTCHA_SITE_KEY"></re-captcha>
-->
